export const dispatchCustomEvent = (event: CustomEvent) => { window.dispatchEvent(event); }

export const subscribe = (type: string, callback: (event: CustomEvent) => void) => window.addEventListener(type, e => {
	if (e.type == type && callback)
		callback(e as CustomEvent);
});